import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-node-col" }
const _hoisted_2 = { class: "flex-node-col" }
const _hoisted_3 = {
  class: "text-center",
  style: {"margin":"10px 0 5px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_grid = _resolveComponent("my-grid")!
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_my_grid, {
        data: _ctx.allUsers,
        columns: _ctx.columns,
        "initial-sort": _ctx.initialSort,
        "initial-group": _ctx.initialGroup,
        filterable: true,
        groupable: true
      }, null, 8, ["data", "columns", "initial-sort", "initial-group"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_k_button, {
        ref: "btnSave",
        onClick: _ctx.saveChanges,
        icon: "save",
        class: "button-save min-w-200"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.localize('Save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 512), [
      [_vShow, _ctx.anyChanges]
    ])
  ]))
}